import { AllContent, RawContentItem } from './bundle.types';

export const allowedContentTypes = [
  'ContentLink',
  'ContentPDF',
  'ContentSlides',
  'ContentLegacyGuide',
  'ContentVideo',
];

export const toAllContent = (rawContent: Array<RawContentItem>): AllContent =>
  rawContent.map((c) => ({
    id: c.value.id,
    name: c.value?.title || c.value?.url || 'Item',
    isPublished: !!c.value.isPublished,
  }));

export const toSellableContent = (
  rawContent: Array<RawContentItem>,
): AllContent =>
  rawContent
    .filter((c) => !c.value.isArchived)
    .map((c) => ({
      id: c.value.id,
      name: c.value?.title || c.value?.url || 'Item',
      isPublished: !!c.value.isPublished,
    }));
